import find from "lodash/find";
import { GameData } from "../GameData";
import { Variable } from "../Variable";

export default function submit(gameData: GameData) {
  const currentBusinessPlan = gameData.currentBusinessPlan;
  if (
    gameData.lastSubmission === gameData.endingSubmission ||
    gameData.money <= 0 ||
    gameData.hearts <= 0
  ) {
    gameData.state = "COMPLETED";
  } else {
    gameData.lastSubmission += 1;
  }
  currentBusinessPlan.submittedAt = new Date();
  currentBusinessPlan.readOnly = true;

  if (gameData.state === "COMPLETED") {
    currentBusinessPlan.variables.forEach((variable) => {
      variable.disabled = true;
    });
  } else {
    const newBusinessPlan = gameData.businessPlans.get(
      gameData.lastSubmission
    )!;
    const newVariables = newBusinessPlan.variables;

    currentBusinessPlan.variables.forEach((variable) => {
      if (!variable) {
        // console.log(
        // 	`Fatal -> disabiliting: can't find variable: "${variable.id} - ${
        // 		variable.name
        // 	}", businessPlan: ${businessPlan.id}`
        // );
        return;
      }
      variable.disabled = true;
      if (!variable.value && variable.value !== 0) {
        // console.log(
        // 	`Fatal -> value of variable "${variable.id} - ${
        // 		variable.name
        // 	}" not valid: ${variable.value}, businessPlan: ${businessPlan.id}`
        // );
        return;
      }
      //TODO valutare se toglierlo, messo perchè da errore se il value è NaN o non disponibile, guardare anche a riga 91
      variable.setValue(variable.value ? variable.value : 0);
      const newVariable = find(newVariables, {
        year: variable.year,
        name: variable.name,
      }) as Variable;
      if (!variable) {
        // console.log(
        // 	`Fatal -> checking feedbacks can't find variable: "${variable.id} - ${
        // 		variable.name
        // 	}", businessPlan: ${businessPlan.id}`
        // );
        return;
      }
      if (!newVariable) {
        // console.log(
        // 	`Fatal -> checking feedbacks can't find NEW variable: "${
        // 		variable.id
        // 	} - ${variable.name}", newBusinessPlan: ${newBusinessPlan.id}`
        // );
        return;
      }
      newVariable.setValue(variable.value || 0);
    });
  }
  return gameData;
}
